import { request } from "umi";

/**
 * Chat (Zulip) credentials for the current user — the only chat-related call
 * that goes through our own backend. Everything else the chat module does
 * talks directly to Zulip's REST API with the returned api_key.
 *
 * GET /api/tenant/chat/token
 */
export type ChatTokenResult = {
  api_key: string;
  email: string;
  zulip_base_url: string;
};

export async function getChatToken() {
  return request<API.ResultObject<ChatTokenResult>>("/api/tenant/chat/token", {
    method: "GET",
    withToken: true,
    // This fires on every page load (ChatProvider is mounted app-wide) and
    // already fails quiet at the call site (see ChatContext.tsx's bootstrap
    // effect) when chat isn't configured for the tenant — skip the global
    // error toast so an unconfigured/unreachable Zulip integration doesn't
    // pop an error on every reload. Explicit sync actions (e.g. the Resync
    // button in ZulipUserSync) intentionally don't set this, so those still
    // surface errors normally.
    skipErrorHandler: true,
  }).then((res) => res.data);
}
